"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function sumo(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M13.5458 6.813C16.0988 9.4875 16.7467 9.96 17.367 10.1302C15.2108 9.86025 13.9943 9.70725 11.9625 8.64075L10.68 10.1332L18.75 11.925C16.2255 14.0715 15.132 15.2153 13.5458 17.1855H10.4925C9.15075 15.222 8.256 14.5845 6.5325 13.7902C8.826 14.0017 10.101 14.1427 11.9625 15.2452L13.3583 13.6777L5.25 11.925C7.1355 10.371 8.23275 9.3345 10.4918 6.813H13.5458ZM10.68 6.44025C11.3775 5.5815 11.6625 5.16375 12.0375 4.5C12.405 5.184 12.6892 5.60625 13.3575 6.44025H10.68ZM13.3575 17.5597C12.6592 18.4185 12.3735 18.8363 12 19.5C11.6325 18.816 11.3475 18.3938 10.68 17.5597H13.3575Z", fill: color }));
}
exports["default"] = sumo;
//# sourceMappingURL=sumo.js.map